import {
  useCompleteTaskMutation,
  useCreateTaskMutation,
  useDeleteTaskMutation,
  useReassignTaskMutation,
} from "generated/graphql";
import useGlobalMessage from "hooks/notifications/useGlobalMessage";

// Centralize task mutation options so all task actions stay in sync.
const TASKS_REFETCH_QUERIES = ["CustomGetMyTasks"];

export function useCompleteTask() {
  return useCompleteTaskMutation({ refetchQueries: TASKS_REFETCH_QUERIES });
}

export function useCreateTask() {
  const { show } = useGlobalMessage();

  return useCreateTaskMutation({
    refetchQueries: TASKS_REFETCH_QUERIES,
    awaitRefetchQueries: true,
    onCompleted: () => {
      show({ message: "Task created." });
    },
    onError: (error) => {
      show({ message: error?.message || "Failed to create task.", options: { variant: "error" } });
    },
  });
}

export function useDeleteTask() {
  return useDeleteTaskMutation({ refetchQueries: TASKS_REFETCH_QUERIES });
}

export function useReassignTask() {
  return useReassignTaskMutation({ refetchQueries: TASKS_REFETCH_QUERIES });
}
